export default "__VITE_ASSET__Btww3tpN__"